import { NotificationManage } from "../../components/NotificationManage"

export const notilogin = t => {
	NotificationManage(
		"info",
		`${t("NotificationManager.Login.loginbefore")}`,
		`${t("NotificationManager.status.info")}`
	)
}

export const notimobile = t => {
	NotificationManage(
		"info",
		`${t("NotificationManager.App.Mobile")}`,
		`${t("NotificationManager.status.info")}`
	)
}

export const notihavemodel = t => {
	NotificationManage(
		"info",
		`${t("NotificationManager.Project.using")}`,
		`${t("NotificationManager.status.info")}`
	)
}

export const notisigninbeforeseeotherprofile = t => {
	NotificationManage(
		"info",
		`${t("NotificationManager.user.seeotherprofile")}`,
		`${t("NotificationManager.status.info")}`
	)
}
